import { Box, Button, Typography, Paper } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { NavLink } from "react-router-dom";

type CreatePageProps = {
  title: string;
  children: React.ReactNode;
  buttonRight?: React.ReactNode;
  footer?: React.ReactNode;
  titleParams?: { [key: string]: string | number };
  className?: string;
  classNameTitle?: string;
};

export function CreatePageList({
  title,
  children,
  buttonRight,
  footer,
  className,
  classNameTitle,
}: CreatePageProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "80vh",
        backgroundColor: "#f0f0f0",
        marginY: 4,
        boxShadow: "0 0 10px rgb(0 0 0 / 15%)",
        paddingRight: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 2,
          borderRadius: 2,
          backgroundColor: "white",
          boxShadow: "0 0 10px rgb(0 0 0 / 15%)",
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          className={classNameTitle}
        >
          <Box>
            <Typography
              variant="h4"
              className={className}
              sx={{ textDecoration: "none", mt: 0 }}
            >
              {title}
            </Typography>
            <Box
              sx={{
                width: "120%",
                height: "4px",
                backgroundColor: "primary.main",
                mt: 1,
              }}
            />
          </Box>
          <Box display="flex" alignItems="center" marginTop={1}>
            {buttonRight}
          </Box>
        </Box>
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            mt: 2,
          }}
        >
          {children}
        </Box>
        {footer && (
          <Box
            sx={{
              mt: 2,
              display: "flex",
              justifyContent: "flex-end",
              borderTop: "1px solid #e0e0e0",
              pt: 2,
            }}
          >
            {footer}
          </Box>
        )}
      </Paper>
    </Box>
  );
}
